import { render, staticRenderFns } from "./DialogFullScreen.vue?vue&type=template&id=324ad1e0&scoped=true&"
import script from "./DialogFullScreen.vue?vue&type=script&lang=ts&"
export * from "./DialogFullScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ad1e0",
  null
  
)

export default component.exports